import ExercisesRepository from "./ExercisesRepository";
import BlogRepository from "./BlogRepository";
import UsersReporitory from "./UsersRepository";
import TokensRepository from "./TokensRepository";
import SubscriptionsRepository from "./SubscriptionsRepository";
import ClassesRepository from "./ClassesRepository";
import LevelsRepository from "./LevelsRepository";
import HomeworksRepository from "./HomeworksRepository";
import ChaptersRepository from "./ChaptersRepository";
import AdministrationRepository from "./AdministrationRepository";
import SchoolsRepository from "./SchoolsRepository";
import ContactFormRepository from "./ContactFormRepository";
import BugsTrackerRepository from "./BugsTrackerRepository";
import TeacherRepository from "./TeacherRepository";
import StudentsRepository from "./StudentsRepository";
import CountriesRepository from "./CountriesRepository";
import TabuleoSubscriptionsRepository from "./TabuleoSubscriptionsRepository";
import GarSubscriptionsRepository from "./GarSubscriptionsRepository";
import GarResourceRepository from "./GarResourceRepository";
import ResourcesRepository from "./ResourcesRepository";
import MockExamTemplateRepository from "./MockExamTemplateRepository";
import UserSessionsRepository from "./UserSessionsRepository";
import GlobalParameterRepository from "./GlobalParameterRepository";

const repositories = {
  exercises: ExercisesRepository,
  blog: BlogRepository,
  users: UsersReporitory,
  tokens: TokensRepository,
  subscriptions: SubscriptionsRepository,
  classes: ClassesRepository,
  levels: LevelsRepository,
  homeworks: HomeworksRepository,
  chapters: ChaptersRepository,
  administration: AdministrationRepository,
  schools: SchoolsRepository,
  contactForm: ContactFormRepository,
  bugs: BugsTrackerRepository,
  teachers: TeacherRepository,
  students: StudentsRepository,
  countries: CountriesRepository,
  tabuleoSubscriptions: TabuleoSubscriptionsRepository,
  garSubscriptions: GarSubscriptionsRepository,
  garResource: GarResourceRepository,
  resources: ResourcesRepository,
  mockExamTemplates: MockExamTemplateRepository,
  sessions: UserSessionsRepository,
  globalParameters: GlobalParameterRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
